<template>
  <section class="index">
    <p class="title">热度排行榜</p>
    <div style="background-color:#F1F3F7;width:100%;height:1px;"></div>

    <section class="content">
      <section>
        <div class="index_range_module">
          <span class="att_range">关注排行榜</span>
          <!-- <nuxt-link class="more" to="/market/hotRange/attention">查看更多<span class="arrow">></span></nuxt-link> -->
        </div>
        <table class="up_range">
          <thead>
            <tr>
              <th>名称</th>
              <th>最新价</th>
              <th>关注数</th>
            </tr>
          </thead>
          <tbody>
            <tr
              class="up_range_data"
              v-for="item in hotRange.attention"
              :key="item.code"
              @click="clickRowJump(item.code)"
            >
              <td>{{item.name}}</td>
              <td :style="{'color':item.netChange>0 ? '#ED2C1D' : '#0FA538'}"><span v-if="item.price">{{item.price}}</span><span
                  class="noHotData"
                  v-if="!item.price"
                >-</span></td>
              <td>{{item.trade}}</td>
            </tr>
          </tbody>

        </table>
      </section>
      <section>
        <div class="index_range_module">
          <span class="att_range">讨论排行榜</span>
          <!-- <nuxt-link class="more" to="/market/hotRange/discuss">查看更多<span class="arrow">></span></nuxt-link> -->
        </div>
        <table class="up_range">
          <thead>
            <tr>
              <th>名称</th>
              <th>最新价</th>
              <th>讨论数</th>
            </tr>
          </thead>
          <tbody>
            <tr
              class="up_range_data"
              v-for="item in hotRange.discuss"
              :key="item.code"
              @click="clickRowJump(item.code)"
            >
              <td>{{item.name}}</td>
              <td :style="{'color':item.netChange>0 ? '#ED2C1D' : '#0FA538'}"><span v-if="item.price">{{item.price}}</span><span
                  class="noHotData"
                  v-if="!item.price"
                >-</span></td>
              <td>{{item.trade}}</td>

            </tr>
          </tbody>

        </table>
      </section>
      <section>
        <div class="index_range_module">
          <span class="att_range">分享交易排行榜</span>
          <!-- <nuxt-link class="more" to="/market/hotRange/transaction">查看更多<span class="arrow">></span></nuxt-link> -->
        </div>
        <table class="up_range">
          <thead>
            <tr>
              <th>名称</th>
              <th>最新价</th>
              <th>交易数</th>
            </tr>
          </thead>
          <tbody>
            <tr
              class="up_range_data"
              v-for="item in hotRange.transaction"
              :key="item.code"
              @click="clickRowJump(item.code)"
            >
              <td>{{item.name}}</td>
              <td :style="{'color':item.netChange>0 ? '#ED2C1D' : '#0FA538'}"><span v-if="item.price">{{item.price}}</span><span
                  class="noHotData"
                  v-if="!item.price"
                >-</span></td>
              <td>{{item.trade}}</td>

            </tr>
          </tbody>

        </table>
      </section>
    </section>

  </section>
</template>

<script>
export default {
  // props:['attention','discuss','transaction'],
  props: ['hotRange'],
  data() {
    return {

    }
  },
  methods: {
    clickRowJump(code) {
      let routeUrl = this.$router.resolve({
        path: `/stock/hk${code}`
      })
      window.open(routeUrl.href, '_blank')
    },
  }
}
</script>

<style lang="less" scoped>
.index {
  width: 100%;
  .title {
    display: inline-block;
    padding-bottom: 12px;
    border-bottom: 3px solid #3278d2;

    font-size: 18px;
    font-family: MicrosoftYaHei-Bold;
    font-weight: bold;
    color: rgba(34, 34, 34, 1);
  }
}
.att_range {
  font-size: 16px;
  font-family: MicrosoftYaHei-Bold;
  font-weight: bold;
  color: rgba(34, 34, 34, 1);
}
.arrow {
  color: rgba(153, 153, 153, 1);
  border-radius: 1px;
  margin-left: 3px;
}
.more {
  float: right;
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
}
.more:hover {
  cursor: pointer;
}
.content {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.content section {
  width: 374px;
  margin-top: 20px;
  // background-color: green;
}

.up_range {
  border-collapse: collapse;
  margin-top: 10px;
  width: 100%;
  .up_range_data:nth-child(odd) {
    background-color: #fafcff;
  }
  .up_range_data:hover {
    cursor: pointer;
    box-shadow: 0px 2px 5px 0px rgba(91, 91, 91, 0.18);
    position: relative;
    width: 374px;
    height: 40px;
    z-index: 205;
  }
}
.up_range td {
  padding: 0 10px;
}
.up_range tr:first-child {
  padding-bottom: 20px;
}
.up_range td:first-child {
  width: 230px;
}
.index_range_module {
  padding: 10px;
  border-bottom: 1px solid #f1f3f7;
}

thead {
  th {
    font-size: 12px;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
  }
  th:first-child {
    text-align: left;
    padding-left: 10px;
    padding-bottom: 10px;
  }
  th:not(:first-child) {
    text-align: right;
    padding-right: 10px;
  }
}
tbody {
  tr {
    height: 40px;
    line-height: 40px;

    td:not(:first-child) {
      text-align: right;
    }
    td {
      font-size: 14px;
      font-weight: 400;
      color: rgba(34, 34, 34, 1);
    }
    td:nth-child(2) {
      font-size: 14px;
      font-weight: bold;
    }
    td:last-child {
      font-size: 14px;
      font-weight: 400;
    }
  }
}

.noHotData {
  color: #222222;
}
</style>

